export default function TabsHashScripts() {
  const tabHash = document.querySelector(`[data-tab-hash="${window.location.hash}"]`);
  if (tabHash) {
    tabHash.click();
  }
}
